import React from 'react';
import { BupSpinner, ModeBupMessage } from '@BUP/components';
import { useAuth, useInboxMessages, useGetOrganizations } from '@BUP/hooks';
import { isRoleAllowed } from '@BUP/services/BraveUp';
import { ADMIN, ECE, COMMENT_OPEN } from '@BUP/constants';
import moment from 'moment';
import 'moment/locale/es';
import { useTranslation } from 'react-i18next';
import styles from './message-list.module.css';

const ModeBupMessageList = () => {
  const { isLoading, messages, error } = useInboxMessages();
  const { user } = useAuth();

  const organizationId = user?.organizations?.id;
  const { data } = useGetOrganizations(organizationId);
  const language = data?.locations?.lenguage.toLowerCase();
  moment.locale(language);

  const [t] = useTranslation();
  const userRole = user?.roles?.type;

  const filterMessages = isRoleAllowed(userRole, [ECE, ADMIN])
    ? messages.filter((message) => message.state === COMMENT_OPEN)
    : messages;

  const shortListMessages = filterMessages.slice(0, 3);
  return (
    <>
      {isLoading ? (
        <div className={styles.loading_wrapper}>
          <BupSpinner size="medium" />
        </div>
      ) : error ? (
        <div className={styles.error_wrapper}>
          <h3 className={styles.error_text}>{t('pages.home.errorMessage')}</h3>
        </div>
      ) : shortListMessages && shortListMessages.length ? (
        shortListMessages.map((message) => (
          <ModeBupMessage
            key={message.id}
            message={message}
            messageText={message.content}
            dateText={`${moment(message?.createdAt).format('lll')}    
          (${moment(message?.createdAt).fromNow()})`}
          />
        ))
      ) : (
        <div className={styles.no_message_wrapper}>
          <h3 className={styles.no_message_text}>
            {t('pages.home.noMessage')}
          </h3>
        </div>
      )}
    </>
  );
};

export default ModeBupMessageList;
